import { render, staticRenderFns } from "./ChatBoxFlex.vue?vue&type=template&id=0dfb31c5&scoped=true&"
import script from "./ChatBoxFlex.vue?vue&type=script&lang=js&"
export * from "./ChatBoxFlex.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxFlex.vue?vue&type=style&index=0&id=0dfb31c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfb31c5",
  null
  
)

export default component.exports